var React = require('react');

function IconBot (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.273 6.632V4.737a1.863 1.863 0 0 0-1.818-1.895h-2.728a2.73 2.73 0 1 0-5.455 0H4.545a1.863 1.863 0 0 0-1.818 1.895v1.895A2.783 2.783 0 0 0 0 9.474a2.783 2.783 0 0 0 2.727 2.842v3.789A1.863 1.863 0 0 0 4.545 18h10.91a1.863 1.863 0 0 0 1.818-1.895v-3.789A2.783 2.783 0 0 0 20 9.474a2.783 2.783 0 0 0-2.727-2.842zm-1.818 9.474H4.545V4.737h10.91zm-8.182-5.685A1.422 1.422 0 1 1 8.636 9a1.391 1.391 0 0 1-1.363 1.421zM14.091 9a1.365 1.365 0 1 1-1.364-1.421A1.391 1.391 0 0 1 14.091 9zm-7.727 3.316h7.273v1.895H6.364z"}));
}

IconBot.defaultProps = {"width":"20","height":"18"};

module.exports = IconBot;

IconBot.default = IconBot;
